import FETCH_HEADERS from 'authJsonHeaders'

export function fetchSovietFiles(id) {
  return fetch(`/pages/soviet/${id}/index_draft/files`, {
    method: 'GET',
    headers: FETCH_HEADERS,
  })
    .then(res => res.json())
}
